import React, { useState } from 'react';
import { functions } from '../firebase/config';
import { httpsCallable } from 'firebase/functions';
import Header from '../components/Header';

const HelpPage = ({ navigateTo, currentPage }) => {
    const [requestType, setRequestType] = useState('Report a Problem');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        setSuccess('');
        try {
            const sendHelpRequestEmail = httpsCallable(functions, 'sendHelpRequestEmail');
            const result = await sendHelpRequestEmail({ requestType, message });
            setSuccess(result.data.message);
            setMessage(''); // Clear form on success
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="max-w-4xl mx-auto p-4 md:p-8">
            <Header title="Help & Feedback" navigateTo={navigateTo} currentPage={currentPage} />
            <div className="bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-2xl font-bold text-gray-800 mb-2">Get in Touch</h2>
                <p className="text-gray-600 mb-6">
                    Have a problem or a great idea? Let us know! Your feedback helps us improve.
                </p>
                
                {success && <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-6" role="alert"><p>{success}</p></div>}
                {error && <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6" role="alert"><p>{error}</p></div>}
                
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="requestType" className="block text-sm font-medium text-gray-700">What is this about?</label>
                        <select
                            id="requestType"
                            value={requestType}
                            onChange={(e) => setRequestType(e.target.value)}
                            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                        >
                            <option>Report a Problem</option>
                            <option>Suggest an Improvement</option>
                        </select>
                    </div>
                    <div>
                        <label htmlFor="message" className="block text-sm font-medium text-gray-700">Your Message</label>
                        <textarea
                            id="message"
                            rows="6"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
                            placeholder="Please be as detailed as possible..."
                            required
                        ></textarea>
                    </div>
                    <div className="text-right">
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300"
                        >
                            {isLoading ? 'Sending...' : 'Send Feedback'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default HelpPage;